import { application, getDateFromString, getParsedPhoneNumber } from 'src/utils'
import {
  getLocaleCodeFromUrl,
  isLATAM,
  displayLastNameFirst,
} from 'src/utils/localeUtils'
import { getLanguageDropdownBasedOnCountry } from './languageUtils'
import { getReadOnlyFields } from 'src/utils/signUpUtils'
import {
  customerContainer,
  storeContainer,
  accountsContainer,
} from 'src/models'
import { countryData } from 'src/views/components/SignUpForms/countryCodeData'
import { FormInputLabels } from 'src/deps'
//import parsePhoneNumber from 'libphonenumber-js'
import { APPConfig } from 'config/appConfig'
import { getLiveEventStatus } from 'src/utils'
import { dateFormatDeps } from 'src/deps'
import './styles.scss'

const enableLiveEvent = getLiveEventStatus()

const formInputLabels = new FormInputLabels()
// const getlocal = getLocalStorage('locale')
// const country = getlocal?.split('-').length ? getlocal?.split('-')[1] : ''

export const userDetailsformInput = async userResponse => {
  const getlocal = getLocaleCodeFromUrl({
    defaultLocale: 'en_US',
    isReverseType: true,
  })
  const locale = APPConfig?.getActiveAppConfig()?.defaultLocale
  const country = getlocal?.split('_').length ? getlocal?.split('_')[1] : ''
  const enableReadonlyFields = APPConfig?.getAppConfig()?.enableReadonlyFields

  const isDefaultLanguage =
    enableReadonlyFields?.defaultLanguageReadOnly?.language || ''
  //checking with readonly function below
  const disableFirstNameField = getReadOnlyFields('firstNameReadOnly', country)
  const disableLastNameField = getReadOnlyFields('lastNameReadOnly', country)
  const defaultLanguageCountries = getReadOnlyFields('addressReadOnly', country)

  const isEmailVerified = userResponse?.customProperties?.isEmailVerifiedFlag
  let showEmailVerificationStatus = ''
  if (isEmailVerified === 'true') {
    showEmailVerificationStatus = 'valEmail'
  } else {
    showEmailVerificationStatus = 'notValEmail'
  }
  const firstName =
    acctype1 == 'Brand Affiliate - Business Entity'
      ? userResponse?.accounts?.name || ''
      : userResponse?.firstName || ''
  const lastName = userResponse?.lastName || ''
  const email = userResponse?.email || ''
  const phoneNumber = userResponse?.phoneNumber || ''

  //Start of parse phonenumber code
  const userCountry =
    userResponse?.accounts?.properties?.find(
      element => element.attributeId === 'countryCode'
    )?.value || ''
  const localCountry = userCountry
    ? userCountry
    : storeContainer?.storeIDValue === 'Canada'
      ? 'CA'
      : storeContainer?.storeIDValue
  let inputCode = countryData()?.find(
    element => element.value === localCountry
  )?.value
  let phoneNumberCode = ''
  if (phoneNumber) {
    let phoneCountry = ''
    const parsedPhoneNumber = await getParsedPhoneNumber(phoneNumber)

    phoneNumberCode = parsedPhoneNumber?.phoneNumberCode
    if (phoneNumberCode === undefined) {
      phoneNumberCode = phoneNumber
    }
    phoneCountry = parsedPhoneNumber?.phoneCountry

    inputCode = phoneCountry || inputCode
  }

  let phoneCountryCodeOptions = []
  countryData()?.forEach(val => phoneCountryCodeOptions.push(val))
  //End of parse phonenumber code

  const gender = userResponse?.gender || ''
  const preferredLanguage = defaultLanguageCountries
    ? isDefaultLanguage
    : userResponse?.customProperties?.preferredLanguage || ''
  const preferredName = userResponse?.customProperties?.preferredName || ''
  const acctype1 = userResponse?.accounts?.type || ''
  const disableFnLn =
    acctype1 == 'Brand Affiliate' ||
    acctype1 == 'Brand Affiliate - Business Entity'
      ? true
      : false

  let homeCountry = ''
  customerContainer?.profileResponse?.accounts?.properties?.forEach(element => {
    if (element.attributeId === 'countryCode') {
      homeCountry = element.value
    }
  })
  const selectLanguage = getLanguageDropdownBasedOnCountry(homeCountry)
  // todo: to check whether country is LATAM :  selectAllLanguages
  // isLATAM ? selectLanguageLATAM : selectAllLanguages

  //Date of Birth Condition check start
  let dob = getDateFromString(userResponse?.dateOfBirth)
  const disableDateOfBirth = dob.time === '' && homeCountry ? false : true
  //Date of Birth Condition check end

  if (homeCountry === 'CA') {
    homeCountry = 'Canada'
  }
  const storeIdBasedOnCountry = storeContainer.storeIDValue
  const handleLang = (event, setFieldValue, optionValue) => {
    setFieldValue('preferredLanguage', optionValue)
  }

  let selectedLanguage =
    selectLanguage?.find(
      option =>
        option?.value === preferredLanguage ||
        option?.label === preferredLanguage
    ) ||
    selectLanguage?.[0] ||
    []

  let selectedLanguageValue = selectedLanguage?.value || preferredLanguage
  let selectedLanguageLabel = selectedLanguage?.label || preferredLanguage
  const hasOnlyOneLanguagePreference =
    selectLanguage && selectLanguage?.length == 1

  const isToEnableEmailVerification =
    APPConfig?.getAppConfig()?.enableEmailVerification == 'true' || false

  if (enableLiveEvent === 'true') {
    let phoneCountryCode = phoneCountryCodeOptions.filter(
      item => item.value === inputCode
    )
    const homeCountry = customerContainer?.getUserHomeCountry() || ''
    const formattedName =
      displayLastNameFirst() ? `${lastName} ${firstName}` : `${firstName} ${lastName}`

    let dataForEventMyProfile = [
      {
        label: 'profileData.name',
        value: firstName && lastName ? formattedName : '-',
      },
      {
        label: 'emailAddressPlaceHolder',
        value: email || '-',
      },
      {
        label: 'phoneNoPlaceHolder',
        value:
          phoneCountryCode[0]?.displayValue && phoneNumberCode
            ? phoneCountryCode[0]?.displayValue + ' ' + phoneNumberCode
            : '-',
      },
      {
        label: 'dateOfBirthPlaceHolder',
        value: dob.date
          ? dateFormatDeps.getDateAsStringWithYear(dob.date)
          : '-',
      },
      {
        label: 'profileData.preferredLanguage',
        value: preferredLanguage || '-',
      },
    ]
    // CN locale label restriction
    // Not required for now
    // if (homeCountry === 'CN') {
    //   dataForEventMyProfile = dataForEventMyProfile.map(item =>
    //     item.label === 'dateOfBirthPlaceHolder' ||
    //     item.label === 'profileData.preferredLanguage'
    //       ? { ...item, value: '-' }
    //       : item
    //   )
    // }
    return dataForEventMyProfile
  }
  return [
    [
      {
        name: 'required_note',
        type: 'div',
        columnType: {
          lg: '12',
        },
        customClassName: 'my-1 required-note',
      },
    ],
    [
      {
        name: 'firstName',
        columnType: {
          lg: '6',
        },
        defaultValue: firstName,
        disabled:
          disableFirstNameField ||
          disableFnLn ||
          homeCountry !== storeIdBasedOnCountry
            ? true
            : false,
        dataTestId: 'qa-first-name',
        placeholderKey: 'firstNamePlaceHolder',
        ariaLabel: 'firstName',
        maxLength: 40,
        required: true,
      },
      {
        name: 'lastName',
        columnType: {
          lg: '6',
        },
        defaultValue: lastName,
        disabled:
          disableLastNameField ||
          disableFnLn ||
          homeCountry !== storeIdBasedOnCountry
            ? true
            : false,
        dataTestId: 'qa-last-name',
        placeholderKey: 'lastNamePlaceHolder',
        ariaLabel: 'lastName',
        maxLength: 40,
        required: true,
      },
    ],
    homeCountry === storeIdBasedOnCountry
      ? [
          {
            name: 'email',
            type: 'accEmail',
            columnType: {
              lg: '6',
            },
            defaultValue: email,
            customClassName: accountsContainer?.duplicateEmailExist
              ? 'duplicate-info-exist ada-checkmark'
              : 'ada-checkmark',
            ariaLabel: 'email',
            dataTestId: 'qa-my-profile-email',
            required: true,
            disabled:
              homeCountry !== storeIdBasedOnCountry
                ? true
                : false || !isToEnableEmailVerification,
            placeholderKey: 'emailAddressPlaceHolder',
          },
          {
            type: showEmailVerificationStatus,
            isToHideLabel: true,
            columnType: {
              lg: '6',
            },
          },
        ]
      : [
          {
            name: 'email',
            type: 'accEmail',
            columnType: {
              lg: '6',
            },
            defaultValue: email,
            customClassName: 'ada-checkmark',
            ariaLabel: 'email',
            dataTestId: 'qa-my-profile-email',
            required: true,
            disabled:
              homeCountry !== storeIdBasedOnCountry
                ? true
                : false || !isToEnableEmailVerification,
            placeholderKey: 'emailAddressPlaceHolder',
          },
        ],
    [
      {
        name: 'phoneCountryCode',
        type: 'select',
        options: [...phoneCountryCodeOptions],
        columnType: {
          lg: `${
            application.width > 1024 && application.width < 1080 ? '0' : '2'
          }`,
          md: '6',
        },
        dataTestId: 'qa-dropdown-countrycode',
        defaultValue: inputCode,
        ariaLabel: 'phoneCountryCode',
        required: true,
        phoneNumberDropDown: true,
        disabled: homeCountry !== storeIdBasedOnCountry ? true : false,
      },
      {
        name: 'mobilePhoneNumber',
        columnType: {
          lg: `${
            application.width > 1024 && application.width < 1080 ? '0' : '4'
          }`,
          md: '6',
        },
        dataTestId: 'qa-create-account-phone',
        placeholderKey: 'phoneNoPlaceHolder',
        defaultValue: phoneNumberCode,
        ariaLabel: 'mobilePhoneNumber',
        disabled: homeCountry !== storeIdBasedOnCountry ? true : false,
        required: true,
        maxLength: 15,
        type: 'mask',
      },
    ],
    [
      {
        name: 'DoB',
        type: 'date',
        isToHideLabel: true,
        disabled: disableDateOfBirth,
        columnType: {
          lg: '6',
        },
        defaultValue: dob.date,
        ariaLabel: 'DoB',
        maxLength: 15,
        customClassName: 'mb-2',
        required: false,
        toolTipInfo: formInputLabels.getFormLabels('distributorMinAge'),
        isFromProfile: true,
        accountDobDisabled: false,
      },
      // {
      //   name: 'gender',
      //   type: 'select',
      //   columnType: {
      //     lg: '6',
      //   },
      //   defaultValue: gender,
      //   disabled: homeCountry !== storeIdBasedOnCountry ? true : false,
      //   options: selectGenderUsCa,
      // },
    ],
    [
      hasOnlyOneLanguagePreference
        ? {
            type: 'text',
            name: 'preferredLanguage',
            defaultValue: selectedLanguageValue,
            dataTestId: 'qa-preferred-language',
            disabled: true,
            value: selectedLanguageLabel,
            customClassName: 'preferred-language-field',
          }
        : {
            name: 'preferredLanguage',
            type: 'dropdown',
            columnType: {
              lg: '12',
            },
            onChange: handleLang,
            defaultValue: selectedLanguageValue,
            options: selectLanguage,
            toolTip: 'langauge', //Important// Do not change value of toolTip
            disabled:
              defaultLanguageCountries ||
              homeCountry !== storeIdBasedOnCountry ||
              hasOnlyOneLanguagePreference
                ? true
                : false,
          },
      // {
      //   name: 'preferredName',
      //   type: 'prNToolTip',
      //   columnType: {
      //     lg: '6',
      //   },
      //   defaultValue: preferredName,
      //   dataTestId: 'qa-user-prefered-name',
      //   placeholderKey: 'preferdNamePlaceHolder',
      //   ariaLabel: 'preferredName',
      //   maxLength: 35,
      //   disabled: homeCountry !== storeIdBasedOnCountry ? true : false,
      // },
    ],
  ]
}
